angular.module('elfium').service('businessCaseService', ['$q', '$uibModal', 'taskService', 'elfiumRestService', 'elfiumUrlService', 'elfiumConvertFieldTypesFilter', 'BUSINESS_CASE_FIELD_TYPES',
    function ($q, $uibModal, taskService, elfiumRestService, elfiumUrlService, elfiumConvertFieldTypesFilter, BUSINESS_CASE_FIELD_TYPES) {
        var that = this;
        that.getBusinessCases = function ()  {
            return elfiumRestService.getBusinessCases().then(that._convertFieldTypes);
        };
        that.getBusinessCasesWithTasks = function ()  {
            return elfiumRestService.getBusinessCases().then(that._convertFieldTypes).then(that._getTasksAndBuildBusinessCases);
        };
        that.searchBusinessCases = function (searchParameters) {
            return elfiumRestService.searchBusinessCases(searchParameters).then(that._convertFieldTypes);
        };
        that.searchBusinessCasesWithTasks = function (searchParameters) {
            return elfiumRestService.searchBusinessCases(searchParameters).then(that._convertFieldTypes).then(that._getTasksAndBuildBusinessCases);
        };
        that.getBusinessCaseWithTasks = function (businessCaseId) {
            var deferred = $q.defer();
            that.getBusinessCase(businessCaseId).then(function (businessCase) {
                that._getTasksAndBuildBusinessCases([businessCase]).then(function (businessCaseDtos) {
                    deferred.resolve(businessCaseDtos[0]);
                }, deferred.reject);
            }, deferred.reject);
            return deferred.promise;
        };
        
        that.getBusinessCase = function (businessCaseId) {
            return elfiumRestService.getBusinessCase(businessCaseId).then(that._convertFieldTypes);
        };
        that.updateBusinessCase = function (businessCase) {
            return elfiumRestService.updateBusinessCase(businessCase);
        };
        that.setBusinessCaseState = function (businessCaseId, state) {
            return that.updateBusinessCase({
                id: businessCaseId,
                stav: state
            });
        };
        that._getTasksAndBuildBusinessCases = function (businessCases) {
            var deferred = $q.defer();
            var searchParameters = {
                obchodniPripadId: that._getBusinessCasesIds(businessCases)
            };
            taskService.searchTasks(searchParameters).then(function (tasks) {
                var businessCasesWithTasks = that._buildBusinessCasesWithTasksDtos(businessCases, tasks);
                deferred.resolve(businessCasesWithTasks);
            }, deferred.reject);
            return deferred.promise;
        };
        that._buildBusinessCasesWithTasksDtos = function (businessCases, tasks) {
            var businessCasesWithTasks = [];
            var tasksByBusinessCaseIdMap = that._buildTasksByBusinessCaseIdMap(tasks);
            angular.forEach(businessCases, function (businessCase) {
                businessCase.tasks = tasksByBusinessCaseIdMap[businessCase.id];
                businessCasesWithTasks.push(businessCase);
            });
            return businessCasesWithTasks;
        };
        that._buildTasksByBusinessCaseIdMap = function (tasks) {
            var tasksByBusinessCaseIdMap = {};
            angular.forEach(tasks, function (task) {
                tasksByBusinessCaseIdMap[task.obchodniPripadId] = tasksByBusinessCaseIdMap[task.obchodniPripadId] || [];
                tasksByBusinessCaseIdMap[task.obchodniPripadId].push(task);
            });
            return tasksByBusinessCaseIdMap;
        };
        that._getBusinessCasesIds = function (businessCases) {
            var businessCaseIds = [];
            angular.forEach(businessCases, function (businessCase) {
                businessCaseIds.push(businessCase.id);
            });
            return businessCaseIds;
        };
        that.openNewBusinessCaseModal  = function () {
            var modalInstance = $uibModal.open({
                templateUrl:  elfiumUrlService.getTemplateUrl('businessCase', 'businessCaseNewModal'),
                controller: 'businessCaseNewModalController'
            });
            return modalInstance.result;
        };
        that.openBusinessCaseDetailModal  = function (businessCaseId) {
            var modalInstance = $uibModal.open({
                templateUrl:  elfiumUrlService.getTemplateUrl('businessCase', 'businessCaseDetailModal'),
                controller: 'businessCaseDetailModalController',
                windowClass: 'business-case-detail-modal',
                resolve: {
                    businessCaseId: function () {
                        return businessCaseId;
                    }
                }
            });
            return modalInstance.result;
        };
        that.createBusinessCaseAndTask = function (businessCase, task) {
            var deferred = $q.defer();
            elfiumRestService.createBusinessCase(businessCase).then(function (businessCaseId) {
                businessCase.id = businessCaseId;
                task.obchodniPripadId = businessCaseId;
                elfiumRestService.createTask(task).then(deferred.resolve, deferred.reject);
            }, deferred.reject);
            return deferred.promise;
        };
        that._convertFieldTypes = function (businessCases) {
            return $q.when(elfiumConvertFieldTypesFilter(BUSINESS_CASE_FIELD_TYPES, businessCases));
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseService.ts